__turbopack_context__.v({
  "bio": "DiscoveryExpertBios-module__W4XAGa__bio",
  "card": "DiscoveryExpertBios-module__W4XAGa__card",
  "cardBody": "DiscoveryExpertBios-module__W4XAGa__cardBody",
  "carousel": "DiscoveryExpertBios-module__W4XAGa__carousel",
  "controls": "DiscoveryExpertBios-module__W4XAGa__controls",
  "eyebrow": "DiscoveryExpertBios-module__W4XAGa__eyebrow",
  "header": "DiscoveryExpertBios-module__W4XAGa__header",
  "image": "DiscoveryExpertBios-module__W4XAGa__image",
  "imageFrame": "DiscoveryExpertBios-module__W4XAGa__imageFrame",
  "imagePlaceholder": "DiscoveryExpertBios-module__W4XAGa__imagePlaceholder",
  "imageWrap": "DiscoveryExpertBios-module__W4XAGa__imageWrap",
  "name": "DiscoveryExpertBios-module__W4XAGa__name",
  "navButton": "DiscoveryExpertBios-module__W4XAGa__navButton",
  "navButtonDisabled": "DiscoveryExpertBios-module__W4XAGa__navButtonDisabled",
  "section": "DiscoveryExpertBios-module__W4XAGa__section",
  "slide": "DiscoveryExpertBios-module__W4XAGa__slide",
  "titleDesktop": "DiscoveryExpertBios-module__W4XAGa__titleDesktop",
  "titleMobile": "DiscoveryExpertBios-module__W4XAGa__titleMobile",
  "titleTablet": "DiscoveryExpertBios-module__W4XAGa__titleTablet",
});
